import { baseNumeral } from '@/utilities/money'

export default (value, isPenny = true, decimal = true, currency = false, locale = null) => {
  if (locale !== null) {
    baseNumeral.locale(locale)
  }

  if (isPenny) {
    return baseNumeral(value / 100).format('0.00[,]00')
  }

  let format = ''

  if (decimal) {
    format = '0.00[,]00'
  } else {
    format = '0[,]00'
  }
  if (currency) {
    format += '$'
  }
  return baseNumeral(value).format(format)
}
